import { TableHeaderCell } from 'common/components';
import { SortDirection, SortField } from 'types/call.type';

type DurationSortHeaderProps = {
    sortField: SortField;
    sortDirection: SortDirection;
    onSortChange: (field: SortField, newSortDirection: SortDirection) => void;
};

export const DurationSortHeader = ({ sortField, sortDirection, onSortChange }: DurationSortHeaderProps) => (
    <TableHeaderCell
        label='Duration'
        sort={{
            isSorted: sortField === 'callDuration',
            direction: sortDirection,
            onSort: () => onSortChange('callDuration', sortDirection === 'asc' ? 'desc' : 'asc'),
        }}
    />
);
